const $inject = ['lbDialogService'];

const lbDialogCont = function (lbDialogService) {
  let vm = this;

  vm.lbDialogService = lbDialogService;
};

lbDialogCont.$inject = $inject;

export default lbDialogCont;



// WEBPACK FOOTER //
// ./src/components/lbDialog/lbDialogCont.js